module.exports = __webpack_public_path__ + "static/media/britta_volland.929c0d51.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/images/mitarbeiter/britta_volland.jpg
// module id = 439
// module chunks = 0